var Vendd = (function (Vendd) {
    'use strict';

    Vendd.MessageBus.subscribe(Vendd.TransactionsHistory.Messages.GetAccountDetails, Vendd.TransactionsHistory, function (envelope) {
        var options = {
            url: 'api/AccountDetails/GetAccountDetails',
            data: {
                accountId: envelope.message.data.accountId,
                transactionCode: envelope.message.data.transactionCode
            },
            onSuccess: onSuccess,
            onFailure: onFailure
        };

        function onSuccess(response) {
            var model = {
                Items: response.data.Items ? response.data.Items : null,
                Translators: response.data.Translators
            };

            Vendd.MessageBus.publishAsync(envelope.sender, new Vendd.TransactionsHistory.Messages.GetAccountDetailsSuccess(model));
        }

        function onFailure(response) {
            Vendd.MessageBus.publishAsync(envelope.sender, new Vendd.TransactionsHistory.Messages.GetAccountDetailsFailure(response));
        }

        Vendd.Service.call(options);
    });

    return Vendd;

})(Vendd || {});
